import React from 'react';
import CategoryComponent from './category/index';

const Category = () => {
  return (
    <CategoryComponent />
  );
};

export default Category;